module.exports = __webpack_public_path__ + "img/0Q3A0072_L_Wood.554e0d6a.jpg";